import React from "react";

const cell4 = (
  { clickFunction, layerColors, isolatedLayer, allLayerFocus },
  ref
) => (
  <svg
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 289.8 223.2"
    className={`cell-svg nav ${isolatedLayer && "isolated"} ${
      allLayerFocus && "all-focus"
    }`}
    onClick={clickFunction}
    ref={ref}
  >
    <g
      id="Color_5"
      className={`${isolatedLayer === 1 ? "fill-group focus" : "fill-group"} `}
    >
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M146.8,178c-8.2-0.2-2.9,12.1-4.4,17.9c-46.7,1.4-93.5-1.2-140.1,3.5c0.6,0.9,1.2,2.3,1.8,2.3
		c19,0.5,38-0.8,56.9-1c27.1-0.3,54.2,1.7,81.4-0.2c9.9-0.7,2.4-12.2,5.1-18.7C148.1,180.5,147.6,178,146.8,178z"
      />
    </g>
    <g
      id="Color_3"
      className={`${isolatedLayer === 3 ? "fill-group focus" : "fill-group"} `}
    >
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M71.6,86.5c0.6-0.9,1-2.2,1.8-2.4c4-1.2,8.1,1,12.2,0.7c-3.3-1.7-5.5-2.3-8.3-3.4C58,73.9,36.9,72.9,16.4,69.8
		c1.2,4,6.8,0.8,6.2,2.3c-3.3,8-9.7-1.3-12.5,1.8c-1.4,1.6-3.9,3.8-5.4,3.7l0.1,1c0.6-0.1,1.3-0.1,1.9,0.1
		c7.2,2.8,14.8,1.8,21.9,4.2c-0.6,0.9-1,2.2-1.8,2.4c-6.8,1.5-13.4-2.5-20.1,0.2c22.2,1.3,44.4,3.3,66.6,5.3
		c-0.6,0.9-1.1,2.3-1.8,2.4c-1.8,0.3-3.6,0.4-5.4,0.5c0,0,0,0,0,0c0.1,0.2,0.2,0.2,0.3,0.5c4-0.1,8.1,0.1,12.1,0.2
		c0.2-5.1,5.5-3.2,8.8-3.5C82.4,88.1,76.7,88.4,71.6,86.5z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M166,1.8c0,0.5,0,1,0,1.5c0,0,0,0.1,0,0.1c0.3,0.4,0.7,0.7,1,1.1c0.2-0.7,0.5-1.3,0.8-2
		c4.2,8.4,0,17.7,2.6,26.3c2.5-1.7-1-5.6,3.5-5c1.5,0.2,2.8,1.7,4.4,2.4c-1.7,3.5-3.6,4.4-3.1,8c0.6,5.5-6,11.3-9.1,17.3
		c4.5-0.1,3.8-7.1,7.1-8.4c0.6-0.2,2.7,0.3,2.5,2.3c2.7-0.3,3.2-3.4,4.4-5.3c1,1.5,2.9,1.5,4.4,1.8c0-0.2,0-0.5,0.2-0.8
		c8.4-13.8,19.8-24.3,27.8-37.8c0.9,0.6,2.4,1.4,2.3,1.7c-2.9,9.8-9.9,16.6-16.2,24.7c-3.9,4.9-7.1,9.7-11.7,13.6c0,0-0.1,0-0.2,0
		c0.1,0.1,0.1,0.2,0.2,0.4c0.2,0.6-0.6,2.5-0.1,2.1c7.1-5.4,10.4-13.7,17.2-19.4c0.2-0.2,2.1,0.9,2.1,1.5c-0.1,2.4-2.1,4.4-4.1,6.1
		c2.7,1.2,3.1-1.7,4.2-2.8c7.7-8.4,12.6-18.2,20.2-26.3c1.6-1.7,4.2-2.5,6.8-2.6c0-0.1,0-0.3,0.1-0.4c0,0,0,0,0-0.1
		C210.9,1.6,188.4,1.7,166,1.8z M178.3,18.4c-4.1,0-3-3.4-2.3-4.4c3-4.2,4.5-1.3,4.5-0.2C180.8,15.5,179.2,18.4,178.3,18.4z
		 M188.9,3.4c1.8-0.8,1.8,1.4,2.6,2.4c-1.5,0-2.9,0-4.4,0C187.7,5,188.1,3.8,188.9,3.4z M188,26.9c-0.9-0.6-1.7-1.2-2.6-1.8
		c5.2-7.1,7.5-16,15.1-21.6c0.3-0.2,2.2,1,2.1,1.4C200.3,13.9,192.5,19.2,188,26.9z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M187.1,5.9c1.5,0,2.9,0,4.4,0"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M244.1,6.2c0,0.8-2.9,0.7-2.7,2.3c-8.3-5.2-18,2.6-19.1,9.8c-0.4,2.7-0.8,3.6-1.1,6.9c5.1-1,5.1-10.5,9.6-4.4
		c4.5-5.3,10.5-9.1,15.1-14.4C245.3,6.3,244.7,6.2,244.1,6.2z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M242.3,174.7c-4.1-0.2-7.2-6.2-11.6-9.3c-1.2-0.8-2.7,0-3.4,1.5c-0.6-0.6-1.1-1.4-1.8-1.6
		c-1.4-0.4-3.3,0.4-4.1-0.4c-3.2-2.9-4.9-6.6-9-8.5c2.7,7.4,11.9,10,13.1,18.4c-0.2,0-0.4,0.1-0.6,0.1c0,0-4.7,1.5-4.7,1.5
		c0,0,47.4,0.1,47.5,0C265.8,176.4,244.3,174.8,242.3,174.7z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M185.8,42.3C185.8,42.3,185.8,42.3,185.8,42.3C185.8,42.3,185.8,42.3,185.8,42.3z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M185.8,42.3c-0.4-0.2-0.8-0.3-1.2-0.4l0,0C185,42,185.4,42.1,185.8,42.3z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M185.8,42.3c0.4,0.2,0.7,0.5,0.9,0.9l0,0C186.5,42.8,186.2,42.5,185.8,42.3z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M184.5,41.9c0.2,0.9,1.6,1.4,2.1,1.4C186.3,42.4,185.5,42.1,184.5,41.9z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M230.8,45.8c-0.2,0.1-1-1.4-1.6-2.3c2.6-1.5,5.1-3.1,7.7-4.7c13.6-8.1,26.6-14.3,39.2-23.8
		c0.9-0.6-1.8-0.3-2.1-0.1c-21.7,12.3-41,25.9-63.3,36.2c-0.2,0.1-1.4-2-1.4-2c20.4-15,42-24.1,62-38c-11.5,3.2-19.4,12.9-30.7,16.3
		c-0.3,0.1-1.1-1.4-1.7-2.3c6.9-4.6,13.3-9.7,20.9-13.4c0.3-0.2,0.1-2.4-0.5-2c-21.4,13.7-41,26.3-60.6,40.8
		c0.9,0.9,1.8,2.4,2.6,2.3c2.2-0.3,5.2-2.4,7.6,0.8c1.2,1.5,3.7-1.1,5.6-2.2c0.5,1.7,1.5,3.3,3.4,2.5c21.8-9.7,42.6-20.5,63.1-32.2
		C262.7,26.8,248.3,39.4,230.8,45.8z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M230.8,45.8c-0.2,0.1-1-1.4-1.6-2.3c15.5-9.8,31.4-17.4,46.9-28.5c0.8-0.6-1.8-0.3-2.1-0.1
		c-13.3,8-25.6,14.4-38.8,23.3c-8.1,5.5-16.2,8.9-24.6,12.9c-0.1,0.1-1.4-2-1.4-2c20.4-15,42-24.1,62-38
		c-11.5,3.2-19.4,12.9-30.7,16.3c-0.3,0.1-1.1-1.4-1.7-2.3c6.9-4.6,13.3-9.7,20.9-13.4c0.3-0.2,0.1-2.4-0.5-2
		c-21.4,13.7-41,26.3-60.6,40.8c0.9,0.9,1.8,2.4,2.6,2.3c2.2-0.3,5.2-2.4,7.6,0.8c1.2,1.5,3.7-1.1,5.6-2.2c0.5,1.7,1.5,3.3,3.4,2.5
		c21.8-9.7,42.6-20.5,63.1-32.2C262.7,26.8,248.3,39.4,230.8,45.8z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M225.5,123.5c14.1,6,27.9,11.9,42.2,17.2V139c-2,0.1-3.6-0.8-5.2-1.8c-2.2-1.3-1.7-4.5-5.1-5.8
		c-20.8-7.9-40.4-17.5-60.7-26.6c0.6-0.9,1.3-2.4,1.7-2.3c19.5,4.5,35.7,15.5,55.2,18.1c-22.1-8.2-44.5-15.6-66.3-24.4
		c-0.6,0.1-1.3,0.2-1.9,0.3c0.2,0.2,0.4,0.4,0.5,0.6c0.6,2.3-4.6,3.8-2.8,5.6c17.1,16.7,39,22.5,59.3,36.1c2,1.3,4.3,2.3,6.8,2
		c-8.6-4.8-17.7-8.4-25.2-15.1C224,125.5,225.3,123.5,225.5,123.5z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M65.5,112c-5.9,3.3-9.9,9.1-16,11.7c-2,0.8-4.7-1.5-2.6-4.1c1.9-2.4,5.5-2.1,6.8-4.5c0.6-1.1,1-4.1-0.5-3.7
		c-12.7,3-23,9.2-34,16.6c-1.6,1.1,3.2,2.3,2,3.6c-1.9,2.1-5.8,2-7.4,4.8c-0.7,1.3,0.9,2.3,1.6,3.4c-2.4,1.3-5.8,1-7,4.4
		c13.3-4.5,24.5-12.9,36.8-19.3c0.3,0.9,1,2,0.7,2.5c-8,10.3-20.5,14.2-28.7,23.8c18.8-10,32.6-25.3,49.6-38.9
		C68,111.4,65.6,112,65.5,112z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M110.3,132c0.1,0.1,0.2,0.1,0.3,0.2C110.5,132.2,110.4,132.1,110.3,132z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M131.5,140.3"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M152.1,132.9c0,0.6,0.2,1.3-0.1,1.7c-0.8,0.9-1.6,3.2-3.4,1c0.3,1.4-0.2,6.1-3.5,3.5c0.8,7.7,2.6,15,6.1,21.9
		c1.6-6.9-7.8-15.7-1.8-20.1c3.5,6.4,3.4,14.2,8.2,19.9c0.7,0.9,2.4-1.5,3.1-1.2c3.1,1.5,0.4,7.4,5.4,8.4
		c-4.6-11.2-7.8-22.8-12.4-34.1C153.5,133.3,152.7,133.2,152.1,132.9z"
      />
    </g>
    <g
      id="Color_2"
      className={`${isolatedLayer === 4 ? "fill-group focus" : "fill-group"} ${
        allLayerFocus && "no-fill"
      }`}
    >
      <g>
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M286.8,150.8c-2-5.1-11.4-2-15.7-7.4c5.6,0.2,11.1,6.4,16.6,3.5c0.6-29.8,0.5-59.5-1.8-89.3
			c-0.3-3.4-6.1,0-9.7,0.6c-3,0.6-1.1-4.3-3.4-3.9c-2.1,0.3-4.1,0.6-6.2,0.6c6.3-3.8,13.9-3.9,20.1-7.9c-0.7-14.3,1.3-28.6-0.9-42.9
			C273.5,2.5,261,3,248.4,3.3c-4.6,7.1-12.2,11.1-17.5,17.5c-4.5-6.1-4.5,3.4-9.6,4.4c0.3-3.3,0.7-4.1,1.1-6.9
			c1.1-7.2,10.8-15,19.1-9.8c-0.3-2.4,6.1-0.9,0.3-4.3c-4.1-2.4-11.9-3.2-15.4,0.6c-7.5,8.1-12.4,17.9-20.2,26.3
			c-1.1,1.2-1.5,4-4.2,2.8c1.9-1.7,3.9-3.8,4.1-6.1c0-0.5-1.9-1.7-2.1-1.5c-6.8,5.8-10.1,14-17.2,19.4c-0.5,0.4,0.3-1.5,0.1-2.1
			c-0.9-2.8-5.1-1-6.7-3.6c-1.2,1.8-1.6,4.9-4.4,5.3c0.2-2-1.9-2.5-2.5-2.3c-3.4,1.3-2.6,8.4-7.1,8.4c3.1-6.1,9.8-11.9,9.1-17.3
			c-0.4-3.6,1.5-4.6,3.1-8c-1.6-0.7-2.9-2.2-4.4-2.4c-4.5-0.6-0.9,3.3-3.5,5c-2.6-8.6,1.6-17.8-2.6-26.3
			c-4.8,10.2,0.7,21.2-2.6,31.5c-0.7-10.5,1.8-21.3-2.6-31.5c-0.9,0.6-2.4,1.2-2.3,1.7c1,11.8,0.2,23.4,0.6,35.1
			c-2.9-11.8,1.5-24.2-2.6-35.9c-0.9,0.6-2.3,1.1-2.4,1.8c-2.3,14.9-0.3,29.2,0.6,43.7c-0.6,0-1.5,0.1-1.6,0c-1-4.7,1-9.5-1.2-13.9
			c-1.4-2.8-2.7-1.1-4.4-0.4c-0.7,0.3-1.6-2.8-3.4-0.6c0-3.3-3.1-4-3.9-6.3c-0.8-2.1,0.3-5.2-0.6-7.6c-0.3-0.8-1.9-1.1-2.3-1.9
			c-2.2-4.7,1-12.1-4-14.1c-3.6-1.4-8.5-2.5-12.8,1c1.2,1.5,0.7,3.7,1.8,5.3c-2-0.2-2.4,1.7-2.3,2.6c0.2,2,0.5,4.2,1.4,6.2
			c1.1,2.2-3.1,3.4-0.9,6.2c1.5,1.9,0.4,4.1,0.5,6c0.3,3.2,3.4,6.1,2.8,9.6c-0.2,1.2-1.9,2.3-2.1,3.6c0,0.4,0.8,1.5,0.7,1.4
			c-5.7-0.6-3.4-6.5-7-10.2c-7.6-8-11.6-19.5-15-30.6C93.4,1.5,84.1,2.5,75,2.7c-0.6,0-1.7,1.9-1.5,2.1
			c12.9,14.5,26.9,26.8,39.1,41.4c-1.6-0.2-2.4,1.1-3.5,1.8c2.8,3.6,6.3,6.6,8.8,10.5c-4-0.2-5.1-4.3-7.9-6.1c-1,1.9-4.8,1.9-4,4.3
			c0.7,2.1,3.3,3.4,4.8,5.4c0.5,0.7-0.4,1.6-0.7,1.5c-2.1-1.2-3.6-3.3-5.4-5.1c-1.3,1.8-3.7,2.5-5,1.4c-2.2-1.8-3.6-5.2-6.4-5.4
			c-1.7-0.2-5.5,0-4.5,2.8c1.3,3.8,6.8,5.5,9.8,9c-15.8-8.1-27.9-21.1-42-31.5c11.2,4.7,19.3,14,28.9,21c0.6-0.9,1.7-2.2,1.5-2.4
			C75.6,40.7,64,29.6,52.3,17.2c-1.6-1.7,0.1-3.9-0.5-5C50,8.4,47,4.3,42.5,3.7c-9.6-1.3-19.2-1-28.8-0.2c-0.7,0.1-1.7,1.9-1.5,2.1
			c3.4,4.4,9.3,1.7,13.6,3.9c3.6,1.8,3,6.2,4.6,9.4c0.5,1,3.1,0.9,2.2,2.6c-0.6,1.2-1.8,2.7-1.3,3.4c3.2,4.4,9,6.5,12.8,9.8
			c12.2,10.5,26.1,17.4,39.2,27.5c0.1,0-1.5,1.8-1.3,2.1c5.9,8,16.6,9,22.5,16.8c-2.8,0.1-4.4-3.9-5.8-3c-2.2,1.5-4,5.3-5.3,4.8
			c-13.3-4.7-25.2-12.5-39.1-15.6c-3.4-0.8,0,1.8,0.3,4.2c-13.2-4.9-26.7-8.1-40.2-12.4c-1.1-0.4-2.9-0.5-2.7-2.5
			c13,3.4,25.3,7.7,38.6,11.3c2,0.5,1.9-1.5,2.6-2.5c-5.1-3.3-11.5-3.5-16.5-7.3c-1.9-1.4,2.6-2,1.4-3c-5.7-4.7-12.6-6.1-18.8-10.3
			c-4.4-3-9.7-3.7-12.5-8.4c2.6,0.2,4.6,1.9,6.9,2.8c3.3,1.4,5.6,4.3,8.9,5.8c11.6,5.1,22.7,10.3,33.9,16.3
			C67.9,67.6,78.2,74.7,90,80.1c1.7,0.8,1.8-1.4,2.5-2.4c-15-8.8-28.4-19.4-43.9-27.7C35.3,42.9,23.3,36,10.5,27.3
			c-0.7-0.4,2.6-0.9,2.3-3.1c-0.4-2.6-3.3-2.2-4.1-3.7c-1.5-2.6,3.4-3.1,3.3-6c-0.2-3.7-3.8-4.1-6.4-5.8c-0.3-0.2-2.1,0.8-2.1,1.5
			C2.2,32.2,0.2,53.8,3.2,75.8c0.6,4,4.7,0.4,6.8-1.9c2.9-3.2,9.3,6.1,12.5-1.8c0.6-1.5-5,1.7-6.2-2.3c20.5,3,41.6,4,60.9,11.5
			c2.8,1.1,5,1.7,8.3,3.4c-4.1,0.4-8.2-1.8-12.2-0.7c-0.8,0.2-1.2,1.5-1.8,2.4c5.1,1.9,10.9,1.6,15.8,4.4c-3.3,0.3-8.6-1.6-8.8,3.5
			C54.8,94,31.3,96.8,7.6,94.7c-0.4,0,1-1.1,1.7-1.1c10.2,0.2,20.6,0.8,30.5-0.4C50,92,61,94.8,71.5,93.2c0.7-0.1,1.2-1.5,1.8-2.4
			c-22.2-2-44.3-4-66.6-5.3c6.7-2.8,13.3,1.2,20.1-0.2c0.8-0.2,1.2-1.5,1.8-2.4c-7.1-2.4-14.8-1.4-21.9-4.2c-1.6-0.6-3.9,0.3-4,1.6
			C1.9,90.5,1.7,100.8,3.2,111c10.6,0.7,20.2-4.9,30.6-5.3c-5.2,3.7-14.6,1.2-16.2,5.7c-1.5,4.2,7.3-0.5,11.8,0.4
			c-2.6,3.1-7.7,0.2-9.1,2.9c-1.1,2,1.9,2.5,3.9,2.4c-7,3.9-17.9-0.2-20.8,8.3c-3.3,9.8-2.9,21.4-0.2,31.8c1.4,5.4,5.2-4.6,10.5-3.3
			c-3.8,4.4-14.7,8.9-9.6,15.8c5-3.7,9.1-8.1,14.2-12c1.4-1.1,0.1,1,0.7,1.5C13.5,164,6.6,168,3.4,173.7c-1.6,2.9,5.8,2,9.4,1.7
			c2.9-0.2,3.3-3.9,5.3-5.8c1-1,2.2-0.9,3.5-0.9c-1.1,2.8-4.1,4.2-5.3,7c7.7,3.1,11.6-4.5,16.8-8.5c1.4-1.1,0.3,0.9,0.6,1.5
			c1.8,3.9-7.1,3.2-1.1,5.7c4.2,1.8,7.4-6.6,11.7-10.1c0.5,3.6-5,6.7-4.3,8.4c2.6,7.4,7.7-7.2,13.1-9.3c0.4,5.3-6.7,6.9-6.1,12.3
			c26.6,2.6,53.1,0.1,79.7,0.5c15.2,0.2,30.5,1.5,45.5-2.2c-0.5-0.8-1.2-2.2-0.8-2.3c2.7-0.8,2.1,4.7,5.1,3.9
			c0.8-0.2,1.8-1.7,1.6-2.3c-1.1-3.5-3.3-6.5-5-9.7c3.9,0.9,2-4.7,4.3-4c1.1,0.4,1.1,3.3,2,3.6c2.4,0.8,2.6-2,2.5-4
			c1,0.1,2.1-0.5,2.7-1c0.2-0.3,0.3-0.5,0.4-0.6c-6-13.4-15.8-25.1-19.7-39.5c6.9,13.9,15.7,26.8,21.9,41.2
			c-1.9,0.8-1.1-3.1-2.2-1.7c0,0,0,0.1,0,0.1c0,0.1-0.2,0.3-0.5,0.5c-0.2,0.4-0.5,0.9-0.8,1.5c-1.5,3,2.9,7,7.7,7.4
			c3,0.2,2.7,7.9,7.1,8.3c9,0.9,18.1,1.6,27.1-0.4c-1.3-8.3-10.5-11-13.1-18.4c4.1,1.9,5.8,5.6,9,8.5c0.8,0.7,2.7,0,4.1,0.4
			c0.7,0.2,1.2,1,1.8,1.6c0.7-1.5,2.1-2.4,3.4-1.5c4.4,3.1,7.4,9.1,11.6,9.3c15,0.5,30.5,2.8,45.5-1.6
			C286.3,165.5,289.4,157.2,286.8,150.8z M143.3,62.8c1.7,1.4,1.8,4.7,3.5,4.8c1.3,0.1,2.5-3.1,4.3-2.7c2,0.4,0,4.4,2.7,4.8
			c1.6,0.2,3.1-0.5,3.5-2.5c1.2,3,2.7,5.5,6.1,3.5c-3.7,6.6-10.5,1-14.9-1.8c-0.4,1-1,2.5-1.7,2.3c-1.6-0.5-3-2-4.4-3.3
			C140.1,65.9,142.5,64.5,143.3,62.8z M157.3,111c-3-0.4-5.9,0-7.9,2.6c0-0.9,0-1.7,0-2.6c0-0.9-0.2-2.2,0.1-2.4
			c1.7-0.9,4.2,2.4,5.5-1.3c0.3-0.8-0.4-2.7-0.4-4.2c1.8,4,5.1-0.8,6.7,1.9c0.4,0.7-1.4,0.4-2.2,0.8
			C157.1,106.8,157.2,109,157.3,111z M132.9,34c0.3-0.3,1.3-0.3,1.5,0c0.6,0.6-0.2,1.5-0.8,1.5C133.1,35.5,132.4,34.6,132.9,34z
			 M17.2,151.2c8.2-9.6,20.7-13.5,28.7-23.8c0.3-0.4-0.4-1.6-0.7-2.5c-12.3,6.4-23.5,14.8-36.8,19.3c1.2-3.3,4.6-3,7-4.4
			c-0.7-1.1-2.3-2.1-1.6-3.4c1.6-2.8,5.5-2.7,7.4-4.8c1.3-1.4-3.6-2.5-2-3.6c11-7.4,21.3-13.6,34-16.6c1.4-0.3,1.1,2.7,0.5,3.7
			c-1.9,2.9-8.7,3.5-6.5,6.4c5.6,7.5,11.7-9.8,20.8-9.7C50.6,124.5,36.2,140.9,17.2,151.2z M72.4,112.7c0.3,0.6,0.9,1.5,0.7,1.6
			c-17.1,14.2-30.9,30.3-49.8,41.3C39.5,141.1,56.8,127.9,72.4,112.7z M49.6,159.1c1.5-5.4,6.6-7.9,9.4-12.4
			c0.2-0.4-1.1-2.2-1.4-2.1c-9.4,3-12,14.4-21.1,18.1c11.2-15.5,28.7-24.1,41.2-38.5c-0.9-0.6-2.1-1.7-2.4-1.5
			c-18.1,14.3-36.4,26.5-50.1,44.4c-2.3-2,0.1-3.2,1.1-4.2c17.1-18.2,36.4-31.6,55.6-47.8c1.4-1.2,0.1-3.6-1.5-4.8
			c-0.4-0.3-1.1-0.1-1.7-0.1c0.4-1.6,1.8-3.4-0.9-4.4c4.6-3.2,10.9-3.3,14.5-7.4c1-1.1-2.1-3.6-1.2-5.7c0.1-0.2,1-0.1,1.6-0.1
			c-0.1,2.8,2.9,4.5,2.1,8c-0.1,0.7,1.4,1.7,2.3,2.6c-1.7,1.7-5.3,1-5.6,2.7c-0.8,5.7,3.8-0.3,6.5,2.5c-1.2,0.6-3,1-3.2,1.8
			c-0.6,2.6,2,2.7,4,2.6c-2.5,2,1.9,2.9,0.7,4.3c-1.4,1.8-3.3,3.3-6.9,0.1c-6.1,12-18.7,16.9-26.9,27.4c0,0,0,0.1,0,0.2
			c-0.1,0-0.1-0.1-0.1-0.1C58.6,147.3,55.7,155,49.6,159.1z M91.6,128.5c-10.6,11.5-23.7,19.4-34.5,31.2c-1,1.1,0-1-0.6-1.5
			c3.6-3.7,7-7.4,10.2-11.6c0,0,0-0.1,0-0.2c0.1,0,0.1,0.1,0.1,0.1c10.5-4.8,17.6-14,25.8-22.2c0.9-0.9,3.2-0.3,5-0.3
			c-6.2,15.6-11.5,31.5-19.3,46.4c2-13.4,10.2-24.5,14.3-37.6C93.5,130.8,92.9,129.8,91.6,128.5z M101.3,128.5
			c0.3,0.3,0.8,0.7,0.8,0.8c-4.2,13.5-9.7,26.1-13.9,39.4C88.6,154.1,96.8,141.9,101.3,128.5z M108.3,131.1
			c-6,12.4-6.7,26.7-14,38.5c4.2-13.9,7.2-28.2,14-41.2c0.3,0.3,0.8,0.6,0.8,0.9c0.1,1.3,0.5,2.1,1.2,2.7
			C109.7,131.7,108.8,131.5,108.3,131.1z M124.9,114.5c-0.8,2.1-2.7,1.8-4.4,1.7c0.9-4.2-2.8-2.4-4-4.6c-0.8-1.5-0.1-4.2-2.2-4.8
			c-0.9-0.3-2.6,1.2-3.2,0.4c-1.4-2,1.6-4.5,0.4-6.7c-0.6-1-1.5-3.2-3.3-1c0.3-3.5,3.5-7.1-0.9-9.6c2.1,0.1,4.7,0.4,5.7,1.3
			c1.8,1.6-2.2,3.9-2.2,6.6c3.8-0.2,4.3,3.7,2.6,6.1c2,0.3,3.4,1.2,4.6,4.3c0.9,2.1,4.1,1.3,5,4.5c0.8-0.5,1.8-1.3,2.5-0.7
			c2.1,1.6,3.9,3.2,6.2,4.2C129.6,118.6,127.3,115.7,124.9,114.5z M131.9,135.5c0-0.6-0.2-1.4,0.1-1.6c0.6-0.6,1.4,0.1,1.6,0.8
			C134.1,136.6,132.4,134.9,131.9,135.5z M128.8,70.1c-3.4,2.8-9,2.6-12.5,6c-0.7,0.7,0.5,3-1.1,3.1c-2.6,0.2-5.3-0.6-7.9-1.5
			c1.5-2,2.9,0,4.4-0.1c3.9-0.3,1.6-4.6,3-6.6c0.7-1,2.8,0.2,4,1.5c1.2-1.9,0.2-4.6,1.2-5.8c1-1.1,1.8,2.1,2.2,1.9
			c3.8-1.2,2.9-5.2,7.1-2.2c0.5-6.1,10.6-10.9,4.5-16.8c-0.1-0.1,0.3-1.3,0.8-1.4c3.4-1.1,0.5,5.1,4.3,4.2c-0.4,3.1-3.3,5.1-4.8,7.3
			C132.1,63,131.6,67.8,128.8,70.1z M140.7,156.5c-6.4,3,0.6,10.6-2.6,15.8c-1.3-6.1-0.1-12.2-1.7-18.4c-0.9-3.7,1.8-6,3.4-8.7
			c2.4,8.9,3.8,18,4.4,27.1C141.2,167.4,142.5,161.6,140.7,156.5z M160.7,159.5c-0.6-0.3-2.3,2.1-3.1,1.2
			c-4.7-5.8-4.6-13.5-8.2-19.9c-6.1,4.5,3.4,13.3,1.8,20.1c-3.5-6.9-5.4-14.2-6.1-21.9c3.3,2.6,3.8-2.1,3.5-3.5c1.8,2.3,2.6,0,3.4-1
			c0.3-0.3,0.1-1.1,0.1-1.7c0.6,0.3,1.4,0.5,1.6,0.9c4.6,11.3,7.8,22.9,12.4,34.1C161.1,166.9,163.7,160.9,160.7,159.5z
			 M169.6,160.9c-5.1-8.5-7.3-17.9-10.4-27.2c-0.3-0.9-0.5-2,0.8-2.6C162.2,141.4,167.9,150.5,169.6,160.9z M169.1,92.3
			c0.9,1,1.7,2.4,1.3,2.5c-6,1.6,0.6,5.2-0.8,8.3c-2.7-2.5-5.7-6.5-3.5-10.5c-0.8-0.3-2.3-0.4-1.6-1.7c0.7-1.3,1.7-2.4,2.5-3.6
			c-0.9-0.3-2.2-0.4-2.4-1c-1-2.3,1.4-5.2,4.2-5.2c-2.1,3.2,0.5,4.8,3.1,6.7C173.2,88.9,167.1,90,169.1,92.3z M283.2,95.3
			c0.7,1.6-0.9,0.7-1.6,0.8c-1.5,0.3-1.7-1.3-2.6-1.8C280.9,92.7,282.5,93.7,283.2,95.3z M259.1,9.7c0.7-0.4,0.9,1.9,0.5,2
			c-7.6,3.7-14,8.8-20.9,13.4c0.6,0.9,1.4,2.4,1.7,2.3c11.4-3.4,19.3-13.1,30.7-16.3c-19.9,13.9-41.6,23-62,38c0,0,1.2,2.1,1.4,2
			c22.3-10.3,41.6-23.9,63.3-36.2c0.3-0.2,3-0.6,2.1,0.1c-12.7,9.5-25.7,15.7-39.2,23.8c-2.6,1.6-5.1,3.2-7.7,4.7
			c0.6,0.9,1.4,2.4,1.6,2.3c17.5-6.5,31.9-19.1,50-24.2c-20.5,11.7-41.3,22.6-63.1,32.2c-1.9,0.8-2.9-0.7-3.4-2.5
			c-1.9,1.1-4.5,3.8-5.6,2.2c-2.4-3.2-5.3-1.1-7.6-0.8c-0.8,0.1-1.7-1.4-2.6-2.3C218.1,36,237.7,23.4,259.1,9.7z M239.7,59.6
			c0.5-0.1,1.1,1.4,1.7,2.3c-5,2.5-10.4,3.6-15.8,5.1c-3.4,0.9-8.7,5.6-10.5,0.2C223.2,64.1,231.1,60.6,239.7,59.6z M231.8,56.7
			c1.8-0.6,3.6-1.8,5.2-1.4c0.9,0.2,3.4,1.5,0.9,3.1c-1,0.7-2.3,1.4-3.4,0.8C233.4,58.7,232.6,57.5,231.8,56.7z M249.3,71.9
			c0.5-0.1,1.1,1.4,1.7,2.3c-6.4,2-12.7,4.7-19.3,4.9c-4.5,0.2-10.6,5.4-13.1-0.6C228.7,75.7,238.8,73.3,249.3,71.9z M181.8,122.3
			c0.9,0.3,2.3,0.5,2.3,0.9c1.2,8.4,9.6,16.9,12.3,24.9c0.5,1.6,2.7,2.9,2,5.7c-6.8-7.1-9.5-16.2-14.7-24.7
			C182.6,127.2,181.6,124.9,181.8,122.3z M184.5,112.7c0.8-0.2,1.5,0.2,1.6,0.9c0,0.3-0.4,0.7-0.8,0.8
			C183.4,114.9,185,113.2,184.5,112.7z M192.4,116.2c0.8-0.2,1.5,0.2,1.6,0.9c0,0.3-0.4,0.7-0.8,0.8
			C191.3,118.4,192.9,116.7,192.4,116.2z M193.2,132c1.7,1.4,2.9,3.2,3.4,5.3c0.1,0.5-1.2,1.2-1.3,0.8c-0.5-3-4.3-3.8-3.8-7
			C192.1,131.4,192.7,131.6,193.2,132z M180.1,107.5c0.6,0.4,1.3,1,0.8,1.7c-0.4,0.5-1.2,1-1.6,0.8
			C176.4,108.5,180.5,108.6,180.1,107.5z M186.6,147.5c-4-5.4-6.9-11.1-8.8-17.4c-1.3-4.4-6.1-7.7-3.9-13
			c6.3,18.2,16.8,34.2,26.3,50.8C192.3,163.5,191.7,154.4,186.6,147.5z M214.2,141.6c-3.4,5.2,6.5,8.9,8.8,14
			c-8.4-3-11-12.4-18.4-16.6c1.7-2.4-4.2-1.7-1.8-4.4c2.9,2.9,5.4,6.3,8.9,8.5c0.4,0.2,2.2-1,2.1-1.4c-0.8-3.8-5-5.4-6.7-8.8
			c0.6,0,1.4-0.2,1.6,0.1c7.3,10.2,18.6,14.9,23.8,26.2C225.9,153.9,221.5,146.2,214.2,141.6z M214.2,129.4
			c5.5,6.8,13.1,11.5,17.5,19.3C225.3,142.9,217.9,138.1,214.2,129.4z M267.7,140.7c-14.2-5.3-28.1-11.2-42.2-17.2
			c-0.2-0.1-1.5,1.9-1.4,2c7.4,6.8,16.6,10.3,25.2,15.1c-2.6,0.3-4.9-0.7-6.8-2c-20.3-13.5-42.2-19.4-59.3-36.1
			c-1.9-1.8,3.4-3.3,2.8-5.6c-0.2-0.9-2-1.3-3.2-1.8c1.7-2.1,3.6-4,5.3-6.1c-1.4-0.7-2.8-1-4.4-0.9c6.7-2.3,12.6,3.2,19.2,1.6
			c1.2-0.3,2.9-0.5,2.7-2.5c3.7,1,7.7,1.7,11.3,0.5c11.3-3.6,22.2-2,33.4-2.2c5.9-0.1,11.5-1.9,17.5-0.8c0.1,0,0.1,1.3,0,1.4
			c-6.5,1.1-12.9-0.8-19.2,1.1c5.7,7.2,17.2,1.5,25.3,3.7c0.1,0,0.1,1,0.1,1.6c-18.4-0.7-36.8-1.9-55.2-2.3c-0.6,0-1.2,1.5-1.7,2.3
			c20.3,4.6,41.3,5.5,61.3,11.4c-28.8-3.3-56.7-10.2-85.9-13.7c-0.5-0.1-1.1,1.4-1.7,2.3c19.5,5.4,39.6,8,58.7,14.9
			c-20.1-3.5-38.9-9.4-59.6-13.9c-2-0.4-1.9,1.5-2.6,2.6c21.9,8.9,44.4,16.3,66.6,24.5c-19.6-2.6-35.8-13.5-55.2-18.1
			c-0.4-0.1-1.1,1.4-1.7,2.3c20.2,9,39.9,18.6,60.7,26.6c3.4,1.3,2.8,4.5,5.1,5.8c1.6,1,3.2,1.9,5.2,1.8
			C267.7,139.6,267.7,140.2,267.7,140.7z M270.3,126.6c-2-0.1-3-1.6-3.5-3.4c2.1-0.1,3.1,1.4,4.4,2.6
			C270.9,126.1,270.6,126.6,270.3,126.6z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M169.6,160.9c-1.7-10.4-7.4-19.5-9.6-29.8c-1.2,0.6-1,1.7-0.8,2.6C162.3,143,164.5,152.4,169.6,160.9z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M184.5,158.1c0.3-0.3,0.5-0.5,0.5-0.5c0,0,0-0.1,0-0.1C184.8,157.6,184.7,157.8,184.5,158.1z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M215.1,67.2c1.7,5.4,7,0.7,10.5-0.2c5.4-1.5,10.8-2.6,15.8-5.1c-0.6-0.9-1.2-2.4-1.7-2.3
			C231.1,60.6,223.2,64.1,215.1,67.2z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M239.7,59.6c-8.6,1-16.5,4.5-24.6,7.6c1.7,5.4,7,0.7,10.5-0.2c5.4-1.5,10.8-2.6,15.8-5.1
			C240.8,61,240.2,59.6,239.7,59.6z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M262.5,48.9c-0.3,0.2-0.1,1-0.1,1.6c6.1-1.8,12.1-3.5,17.5-7c-3.5-0.2-6.5,1.4-9.6,2.8
			C267.7,47.4,264.9,47.5,262.5,48.9z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M256.3,46.2c7.5-0.8,14.2-4.1,21-7c-4.9,0.1-9.6,1.9-13.8,4C261.1,44.3,257.7,43.1,256.3,46.2z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M249.3,71.6c6.1-4,14.5-1.6,20.1-7c-6.5,1.3-12.8,3.9-19.3,4c-0.7,0-3.3-1.7-0.8-2.9
			c6.1-2.9,12.9-3.9,19.2-6.3c-2.5-1.7-5.6,1.1-8.5-2c-2.2-2.2-7.9,2.4-10.2,1.1c-5.4-2.9,5.8-3.5,8.3-6.1
			c-5.2-1.9-9.2,4.9-12.7,2.8c-5.9-3.7,1-2.2-0.7-3.1c-2.6-1.3-6.2,1-9.3,2.2c-18.4,7-37.4,10.6-54.9,19.8c-0.9,0.5-0.1,4.2,0.2,6.3
			c0.4,2.5,3.6-1.2,5.5,0.2c0.8,0.6,1.3,2.3,1.8,2.2c5.4-0.5,10.4-3.6,15.8-3.8c1,0,2.8,0.4,2.6,2.4c1.8,0,5.1-0.5,5.3,2.6
			c20.4-3.1,40.7-7.2,60.4-13.1C264.6,69.4,254.5,78.6,249.3,71.6z M225.6,67c-3.4,0.9-8.7,5.6-10.5,0.2c8-3.1,15.9-6.6,24.6-7.6
			c0.5-0.1,1.1,1.4,1.7,2.3C236.4,64.4,231,65.5,225.6,67z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M239.7,59.6c-8.6,1-16.5,4.5-24.6,7.6c1.7,5.4,7,0.7,10.5-0.2c5.4-1.5,10.8-2.6,15.8-5.1
			C240.8,61,240.2,59.6,239.7,59.6z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M272.9,156.5c3.4,1.1,7.2,1.3,8.8,5.3c-6-3.1-12.6-5.2-18.4-8.8C267.1,152.5,269.6,155.4,272.9,156.5z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M265.9,147.7c6.5,1.8,12.7,4.2,18.4,7.9C277.6,154.4,271.4,151.8,265.9,147.7z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M242.3,146c-0.1-0.3,0-0.6,0-0.9c11.8,6.6,21.2,15.7,31.2,24.8c1.1,1-1,0-1.5,0.6c-0.9-0.9-1.6-2.1-2.7-2.5
			c-1.4-0.5-5.2-0.6-5.2,2.5c-7.9-4.8-14.3-11.3-21-17.5c1.3-0.1,2.4,0.8,3.5,0.7c0.4,0,0.8-1,0.8-1.6C247.2,149,243,149,242.3,146z
			"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M242.8,52.7c0.7-0.1,1.5-0.3,2.2-0.4C245.4,52.2,242.8,51.8,242.8,52.7z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M225.6,67c-3.4,0.9-8.7,5.6-10.5,0.2c8-3.1,15.9-6.6,24.6-7.6c0.5-0.1,1.1,1.4,1.7,2.3
			C236.4,64.4,231,65.5,225.6,67z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M239.7,59.6c-8.6,1-16.5,4.5-24.6,7.6c1.7,5.4,7,0.7,10.5-0.2c5.4-1.5,10.8-2.6,15.8-5.1
			C240.8,61,240.2,59.6,239.7,59.6z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M95.3,112.3C95.3,112.3,95.3,112.3,95.3,112.3c0.1,0.1,0.2,0.1,0.3,0.1c0,0,0,0,0,0c0.1,0,0.2,0.1,0.3,0.1
			c0,0,0,0,0,0c-0.5-0.7-0.9-1.7-1.4-2.1c-0.1,0.8,0.1,1.3,0.5,1.6c0,0,0,0,0,0C95.1,112.2,95.2,112.2,95.3,112.3z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M95.1,112.1C95.1,112.1,95.1,112.1,95.1,112.1C95.1,112.1,95.1,112.1,95.1,112.1z"
        />
        <polygon
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          points="95.9,112.6 95.9,112.6 95.9,112.6 		"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M95.3,112.3C95.3,112.3,95.3,112.3,95.3,112.3C95.3,112.3,95.3,112.3,95.3,112.3z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M95.6,112.5C95.6,112.5,95.6,112.4,95.6,112.5C95.6,112.4,95.6,112.5,95.6,112.5z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M53.7,115.2c0.1-0.2,0.2-0.5,0.3-0.8c0,0,0,0,0,0c0,0.1-0.1,0.2-0.1,0.4c0,0,0,0.1,0,0.1
			C53.8,115,53.8,115.1,53.7,115.2c-0.2,0.2-0.3,0.3-0.5,0.5c0,0-0.1,0.1-0.1,0.1c-0.1,0.1-0.3,0.3-0.4,0.4c0,0-0.1,0.1-0.2,0.1
			c-0.2,0.1-0.3,0.2-0.5,0.4c0,0-0.1,0-0.1,0.1c-0.2,0.1-0.4,0.3-0.6,0.4C52.3,116.7,53.2,116.2,53.7,115.2z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M53.7,115.2c-0.1,0.2-0.3,0.4-0.5,0.6C53.4,115.5,53.6,115.3,53.7,115.2z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M52,116.7c0.2-0.1,0.3-0.2,0.5-0.4C52.4,116.4,52.2,116.6,52,116.7z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M53.7,115.2c0.1-0.1,0.1-0.2,0.2-0.3C53.8,115,53.8,115.1,53.7,115.2z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M51.9,116.7c-0.2,0.1-0.4,0.3-0.6,0.4h0C51.5,117,51.7,116.9,51.9,116.7z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M54,114.4c0,0.1-0.1,0.2-0.1,0.4C53.9,114.7,54,114.6,54,114.4z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M52.7,116.2c0.1-0.1,0.3-0.2,0.4-0.4C53,116,52.8,116.1,52.7,116.2z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M40.3,134.9c-0.1,0.1-0.1,0.1-0.2,0.2c-0.9,0.8-1.8,1.5-2.8,2.3c-0.1,0.1-0.2,0.2-0.3,0.3
			c-2,1.6-4,3.2-6.1,4.7c-0.2,0.2-0.4,0.3-0.7,0.5c-0.8,0.6-1.5,1.1-2.3,1.7c-0.3,0.2-0.7,0.5-1,0.7c-0.7,0.5-1.4,0.9-2.1,1.4
			c-0.4,0.2-0.7,0.5-1.1,0.7c-0.7,0.5-1.5,0.9-2.2,1.4c-0.3,0.2-0.7,0.4-1,0.6c-1.1,0.6-2.2,1.3-3.3,1.9
			c15.9-8.5,28.3-20.8,42.1-32.6C52.9,123.9,46.7,129.5,40.3,134.9z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M37.3,137.4c-0.1,0.1-0.2,0.2-0.3,0.3C37.1,137.5,37.2,137.5,37.3,137.4z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M40.3,134.9c-0.1,0.1-0.1,0.1-0.2,0.2C40.1,135,40.2,135,40.3,134.9z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M30.9,142.4c-0.2,0.2-0.4,0.3-0.7,0.5C30.4,142.7,30.7,142.5,30.9,142.4z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M21.5,148.8c-0.3,0.2-0.7,0.4-1,0.6C20.8,149.2,21.1,149,21.5,148.8z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M24.8,146.7c-0.4,0.2-0.7,0.5-1.1,0.7C24,147.2,24.4,146.9,24.8,146.7z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M27.9,144.5c-0.3,0.2-0.7,0.5-1,0.7C27.2,145,27.6,144.8,27.9,144.5z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M65,112.4c0,0,0.1,0,0.1-0.1c0.2-0.1,0.3-0.1,0.5-0.2c0.1,0,0.2,0,0.2-0.1c0.2,0,0.3-0.1,0.5-0.1
			c0.2,0,0.5-0.1,0.7-0.1c0,0,0,0,0,0c-0.2-0.2-1.5,0.1-1.6,0.2c-0.4,0.2-0.7,0.4-1,0.6h0C64.6,112.6,64.8,112.5,65,112.4z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M65.7,112.2c-0.2,0.1-0.4,0.1-0.5,0.2C65.3,112.3,65.5,112.2,65.7,112.2z"
        />
        <polygon
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          points="67.1,111.9 67.1,111.9 67.1,111.9 		"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M64.5,112.7c0.2-0.1,0.4-0.2,0.6-0.2C64.8,112.5,64.6,112.6,64.5,112.7z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M66.4,112c-0.2,0-0.3,0.1-0.5,0.1C66.1,112.1,66.2,112,66.4,112z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M50.7,123.4c0.5-0.1,1.1-0.3,1.7-0.6c0,0,0,0,0,0c0.6-0.3,1.1-0.7,1.7-1.2c0,0,0,0,0.1-0.1
			c0.4-0.3,0.8-0.7,1.2-1.1c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.2-0.2,0.2-0.2c0.1-0.1,0.2-0.2,0.3-0.3
			c0.3-0.3,0.5-0.5,0.8-0.8c0.1-0.1,0.1-0.1,0.2-0.2c-2.2,1.9-4.5,3.8-7.1,5.1C50.4,123.4,50.5,123.4,50.7,123.4
			C50.6,123.4,50.7,123.4,50.7,123.4z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M54.1,121.5C54.1,121.5,54.1,121.5,54.1,121.5C54.1,121.5,54.1,121.5,54.1,121.5z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M57.2,118.6c-0.3,0.3-0.5,0.5-0.8,0.8C56.6,119.1,56.9,118.9,57.2,118.6z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M56.1,119.7c-0.1,0.1-0.2,0.2-0.2,0.2C55.9,119.8,56,119.8,56.1,119.7z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M50.6,123.4C50.6,123.4,50.7,123.4,50.6,123.4C50.7,123.4,50.6,123.4,50.6,123.4z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M55.5,120.2c0,0-0.1,0.1-0.1,0.1C55.4,120.3,55.5,120.3,55.5,120.2z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M52.3,122.8C52.3,122.8,52.3,122.8,52.3,122.8C52.3,122.8,52.3,122.8,52.3,122.8z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M53.6,111.5C53.7,111.5,53.7,111.5,53.6,111.5c0.1,0,0.2,0.1,0.2,0.1c0,0,0,0,0,0c0.1,0,0.1,0.1,0.1,0.2
			c0,0,0,0,0,0c-0.2-0.2-0.4-0.4-0.8-0.3c0.1,0,0.2,0,0.2,0C53.5,111.5,53.6,111.5,53.6,111.5z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M53.9,111.6c0,0-0.1-0.1-0.2-0.1C53.8,111.5,53.8,111.6,53.9,111.6z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M53.9,111.6c0.1,0,0.1,0.1,0.1,0.2C54,111.7,53.9,111.7,53.9,111.6z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M53.5,111.5c0.1,0,0.1,0,0.1,0C53.6,111.5,53.5,111.5,53.5,111.5z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M65,112.4c0,0,0.1,0,0.1-0.1C65.1,112.4,65.1,112.4,65,112.4z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M53.3,115.7c0,0-0.1,0.1-0.1,0.1C53.2,115.8,53.2,115.8,53.3,115.7z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M65.7,112.2c0.1,0,0.2,0,0.2-0.1C65.9,112.2,65.8,112.2,65.7,112.2z"
        />
        <polygon
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          points="64.5,112.7 64.5,112.7 64.5,112.7 		"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M59.1,118.8c-6.4,5.3-12.5,10.8-18.8,16.1C46.6,129.6,52.7,124.1,59.1,118.8z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M59.3,118.6c-0.1,0.1-0.2,0.1-0.3,0.2C59.1,118.8,59.2,118.7,59.3,118.6C59.3,118.6,59.3,118.6,59.3,118.6z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M53.9,114.8C53.9,114.8,53.9,114.8,53.9,114.8C53.9,114.8,53.9,114.8,53.9,114.8z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M66.4,112c0.2,0,0.5-0.1,0.7-0.1C66.9,111.9,66.6,112,66.4,112z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M40.1,135.1c-0.9,0.8-1.8,1.5-2.8,2.3C38.2,136.6,39.1,135.9,40.1,135.1z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M57.4,118.4c-0.1,0.1-0.1,0.1-0.2,0.2C57.2,118.5,57.3,118.4,57.4,118.4C57.4,118.4,57.4,118.4,57.4,118.4z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M52.3,122.8c0.6-0.3,1.1-0.7,1.7-1.2C53.5,122.1,52.9,122.5,52.3,122.8z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M50.7,123.4c0.5-0.1,1.1-0.3,1.7-0.6C51.8,123.1,51.2,123.3,50.7,123.4z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M52,116.7c0,0-0.1,0-0.1,0.1C52,116.7,52,116.7,52,116.7z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M54.1,121.5c0.4-0.3,0.8-0.7,1.2-1.1C55,120.8,54.5,121.2,54.1,121.5z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M55.5,120.2c0.1-0.1,0.2-0.2,0.3-0.3C55.7,120,55.6,120.1,55.5,120.2z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M52.7,116.2c0,0-0.1,0.1-0.2,0.1C52.6,116.3,52.6,116.2,52.7,116.2z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M30.2,142.9c-0.8,0.6-1.5,1.1-2.3,1.7C28.7,144,29.4,143.4,30.2,142.9z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M53.6,111.5C53.7,111.5,53.7,111.5,53.6,111.5C53.7,111.5,53.7,111.5,53.6,111.5z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M56.4,119.4c-0.1,0.1-0.2,0.2-0.3,0.3C56.2,119.6,56.3,119.5,56.4,119.4z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M53.9,111.6C53.9,111.6,53.9,111.6,53.9,111.6C53.9,111.6,53.9,111.6,53.9,111.6z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M23.7,147.4c-0.7,0.5-1.5,0.9-2.2,1.4C22.2,148.3,23,147.9,23.7,147.4z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M20.5,149.4c-1.1,0.6-2.2,1.3-3.3,1.9C18.3,150.6,19.4,150,20.5,149.4z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M50.6,123.4c-0.1,0-0.3,0-0.4,0l0,0C50.4,123.4,50.5,123.4,50.6,123.4z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M53.2,111.5c0.1,0,0.2,0,0.2,0C53.4,111.5,53.3,111.5,53.2,111.5z"
        />
        <polygon
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          points="54,114.4 54,114.4 54,114.4 		"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M30.9,142.4c2.1-1.5,4.1-3.1,6.1-4.7C35,139.3,32.9,140.8,30.9,142.4z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M26.9,145.3c-0.7,0.5-1.4,0.9-2.1,1.4C25.5,146.2,26.2,145.7,26.9,145.3z"
        />
        <polygon
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          points="54,111.8 54,111.8 54,111.8 		"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M184.6,157.9c0.2-0.2,0.5-0.4,0.8-0.6c0-0.1-0.1-0.1-0.1-0.2C185.1,157.2,184.9,157.5,184.6,157.9z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M110.3,132c0.1,0.1,0.2,0.1,0.3,0.2C110.5,132.2,110.4,132.1,110.3,132z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M116.2,133.7c-1.8-0.4-4.1-0.4-5.6-1.5c0.3,0.3,0.5,0.7,0.2,1.4c-4,11.6-7.7,23-9.5,35.1
			c4.8-7.8,4.2-17.2,7.9-25.4c0.9,0.6,2.4,1.2,2.3,1.7c-0.6,8.3-3.9,16.1-4.1,24.5C111.8,158,112.6,145.5,116.2,133.7z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M132.1,157.4c0.1-1.8-1.3-3.8,0.7-5.3c-0.7,6.7,1.3,13.5-0.9,20.1C131.9,167.3,131.7,162.4,132.1,157.4z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M128.4,160c-0.6,3.8,1.2,7.7-0.9,11.4C128.2,167.6,126.2,163.7,128.4,160z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M131.5,140.3"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M165,128.5c-0.1-0.4-1-0.6-1.6-0.9c1.6,8,6.8,14.4,9.6,21.9C174.6,142.3,166.6,136.2,165,128.5z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M175.9,66.2c-0.8-1.7,1.1-0.2,1.6-0.8C177.7,67.3,176,66.4,175.9,66.2z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M133.1,127.5c-0.6-1.8,1.6-0.2,2.3-0.8C134.8,127.8,133.3,128,133.1,127.5z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M189.7,60.2c0.6,0,1.4-0.2,1.6,0.1c0.6,0.6-0.2,1.2-0.8,1.7C190.3,61.3,190,60.8,189.7,60.2z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M183.6,63.7c-0.9,0.2-1.2-0.1-0.9-0.9c0.5-1.3,1.6-0.8,2.6-0.9c0,0.6,0.2,1.4-0.1,1.7
			C184.9,63.9,184.2,63.6,183.6,63.7z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M184.5,158.1c0.3-0.3,0.5-0.5,0.5-0.5c0,0,0-0.1,0-0.1C184.8,157.6,184.7,157.8,184.5,158.1z"
        />
        <g>
          <path
            className="cell-base"
            vectorEffect="non-scaling-stroke"
            d="M40.1,207.4c0.4-0.5,1.1-0.6,1.7-0.9c0,1.5,0.2,2.9-0.1,4.4c-0.1,0.7-0.9,1.3-1.6,0.8
				C38.5,210.3,39,208.7,40.1,207.4z"
          />
          <path
            className="cell-base"
            vectorEffect="non-scaling-stroke"
            d="M62.7,211.7c0.8-0.2,1.3,0.3,1.8,0.9C63.6,212.8,63.2,212.3,62.7,211.7z"
          />
          <path
            className="cell-base"
            vectorEffect="non-scaling-stroke"
            d="M95.1,211.6c-0.2,0-0.6-0.5-0.9-0.8c0.9-0.5,1.2-2.1,2.6-1.8C96.6,209.9,98.1,211,95.1,211.6z"
          />
          <path
            className="cell-base"
            vectorEffect="non-scaling-stroke"
            d="M192.4,200.3c-0.9,0.3-1.3-0.3-1.8-0.9c2,0,4.1,0,6.1,0C195.6,201.1,193.8,199.8,192.4,200.3z"
          />
          <path
            className="cell-base"
            vectorEffect="non-scaling-stroke"
            d="M216.8,195c-0.2,0.1-0.6,0-0.8,0c0.6-1.6,1.9-3.6,3.2-2.3C220.3,193.8,217.9,194.3,216.8,195z"
          />
          <path
            className="cell-base"
            vectorEffect="non-scaling-stroke"
            d="M276.4,184.5c-0.6,0-1.4,0.2-1.6-0.1c-0.6-0.6,0.1-1.4,0.8-1.6c0.8-0.2,1.9-0.4,2.5,0.1
				c0.3,0.2,0.3,1.2,0,1.5C277.8,184.7,277,184.5,276.4,184.5z"
          />
          <path
            className="cell-base"
            vectorEffect="non-scaling-stroke"
            d="M255.3,202c-0.4,1.3-1.6,0.8-2.6,0.9c0-0.6-0.2-1.4,0.1-1.7c0.6-0.6,1.6-0.7,2.5-1
				C255.4,200.9,255.5,201.5,255.3,202z"
          />
          <path
            className="cell-base"
            vectorEffect="non-scaling-stroke"
            d="M272.8,210.8c0.7,1.8-1.2,0.3-1.6,0.8c0-0.6,0-1.2,0-1.8C271.8,210.2,272.6,210.4,272.8,210.8z"
          />
          <path
            className="cell-base"
            vectorEffect="non-scaling-stroke"
            d="M223,211.7c-0.6,0.3-1.2,0.8-1.7,0.8c-0.7-0.1-1.4-1-0.8-1.5C221.2,210.3,222.2,211.2,223,211.7z"
          />
          <path
            className="cell-base"
            vectorEffect="non-scaling-stroke"
            d="M182.7,210.9c1.3-0.3,2.3,0.6,1.5,1.5c-0.5,0.6-1.6-0.3-2.4-0.7C182.1,211.4,182.4,211,182.7,210.9z"
          />
          <path
            className="cell-base"
            vectorEffect="non-scaling-stroke"
            d="M162.6,201.1c-0.3,0-0.8-0.5-0.7-0.7c0.1-0.7,1-1.3,1.5-0.8C163.9,200.1,163.2,201,162.6,201.1z"
          />
          <path
            className="cell-base"
            vectorEffect="non-scaling-stroke"
            d="M163.4,189.7c-0.8,0.4-1.2-0.1-0.8-0.8c0.3-0.7,1.1-1.3,1.6-0.8C164.8,188.7,164.1,189.4,163.4,189.7z"
          />
        </g>
      </g>
      <g>
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M72.4,186.2c0.5,0.2,1.3,0.3,1.6,0c0.6-0.6-0.1-1.3-0.8-1.6c-0.5-0.2-1.3-0.3-1.6,0
			C71.1,185.2,71.7,186,72.4,186.2z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M129.3,189.8c0.2-1.9-1.3-0.3-1.8-0.9C127.3,190.9,128.8,189.2,129.3,189.8z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M13.8,184.4c0.3,0.2,1.2-0.3,1.6-0.8c0.5-0.7-0.2-1.3-0.8-1.7C14.7,182.9,11.3,183.1,13.8,184.4z"
        />
      </g>
    </g>
    <g
      id="Color_1"
      className={`${isolatedLayer === 2 ? "fill-group focus" : "fill-group"} `}
    >
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M281.7,96.1c-1.5,0.3-1.7-1.3-2.6-1.8c1.8-1.6,3.5-0.6,4.2,1C284,96.9,282.4,96,281.7,96.1z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M266.8,123.2c0.5,1.8,1.5,3.3,3.5,3.4c0.3,0,0.6-0.5,0.9-0.8C269.9,124.7,268.9,123.1,266.8,123.2z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M231.8,148.6c-4.4-7.8-12.1-12.5-17.5-19.3C217.9,138.1,225.3,142.9,231.8,148.6z"
      />
      <g>
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M3.3,210.9c1.5-1.8,3.6,1.2,3.8,0.6c1.4-3.9-8.4-6-1.2-6.8c13.4-1.5,26.4-4,40.2-2.2c3.9,0.5,8.1-0.7,12.2-1
			c9.6-0.7,19.2,0.7,28.9,1.1c20.7,0.8,41.4,1,62.2-0.5c-1.1-7.6-1.7-15.1-0.5-22.7c0.2-1.2,2.4-2.5,4-2.5
			c17.5-0.1,35.1,0.5,52.5-0.1c19.1-0.7,38.2,0,57.3-0.1c-13.3,0-43.4-0.6-43.7-0.4c-0.9,0.4-1.7,0.3-2.3-0.2
			c-6.1,0.3-12.1-0.2-18.2-0.8c-4.4-0.4-4.1-8-7.1-8.3c-4.8-0.4-9.2-4.4-7.7-7.4c0.2-0.5,0.5-0.9,0.6-1.2l-0.1-0.1
			c-0.6,0.5-1.5,1-2.4,0.9c0.1,2-0.1,4.7-2.5,4c-0.9-0.3-0.9-3.3-2-3.6c-2.3-0.7-0.4,5-4.3,4c1.7,3.3,3.9,6.3,5,9.7
			c0.2,0.6-0.8,2.1-1.6,2.3c-3,0.8-2.4-4.7-5.1-3.9c-0.5,0.1,0.3,1.5,0.8,2.3c-15,3.7-30.4,2.5-45.5,2.2c-3.9-0.1-7.8,0-11.8,0
			c0.2,0.3,0.4,0.6,0.4,1c1.4,0,2.9,0,4.3,0c6.3,0,13.6-1.9,18.8,1.1c5.1,2.9,2,9.7,1.9,14.9c0,0.6-1.5,1.6-2.3,1.6
			c-17.5-0.3-34.6,3.2-52.4-0.5c-2.6-0.5,0.5-3.7-0.4-4.1c-2.7-1.2-2.8,4.5-5.9,4.6c-6.4,0.4-12.8-0.4-19.2,0.4
			c-19,2.2-37.4,0.7-56.1,1.5c-0.9-1.6-2.6-7.3-2.9-8.9l0.3,33.4c14-0.4,28-0.7,42-0.9c-12.8-0.1-25.6-0.5-38.5-1.6
			C2.8,218.6,1,213.6,3.3,210.9z M142.4,195.9c1.5-5.8-3.8-18.1,4.4-17.9c0.8,0,1.3,2.5,0.7,3.9c-2.7,6.6,4.7,18.1-5.1,18.7
			c-27.2,1.8-54.3-0.1-81.4,0.2c-19,0.2-37.9,1.5-56.9,1c-0.6,0-1.2-1.5-1.8-2.3c0,0,43.4-3.1,59-2.9
			C81.5,196.7,142.4,195.9,142.4,195.9z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M288,203.9c-0.1,4.4-0.3,8.7-1.1,13.1c-56.9,3.2-113.8,1.5-170.8,2.3c-12.3,0.2-24.7,0.5-37,0.8
			c69.8-0.4,139.6,0.7,209.5-0.5c0.1-5.1,0.1-10.3,0.1-15.4C288.5,204.1,288.2,204,288,203.9z"
        />
        <path
          className="cell-base"
          vectorEffect="non-scaling-stroke"
          d="M182.6,164.3c-5.3-0.3,0.9,7.3,3,10.3c0.6,0.9,2-0.8,3.2-1.5C186.4,170.2,185.7,164.5,182.6,164.3z"
        />
      </g>
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M2.1,185.5c0.3-2.1,0.8-4.1,1.3-6.1c0.2-0.8,1.5-1.4,2.4-1.7c1.7-0.5,3.6,1.4,4.1,1.1
		c5.7-2.4,11.5-1.1,16.9-1.3c7-0.3,14.1-0.4,21.1-0.5c0.1-0.2,0.2-0.5,0.4-0.7c0.1-0.1,0.1-0.2,0.2-0.3c-0.6-0.1-1.1-0.1-1.7-0.1
		c-0.6-5.4,6.5-7,6.1-12.3c-5.4,2.1-10.5,16.7-13.1,9.3c-0.6-1.8,4.8-4.8,4.3-8.4c-4.4,3.5-7.5,11.9-11.7,10.1
		c-6-2.5,2.9-1.8,1.1-5.7c-0.3-0.6,0.8-2.6-0.6-1.5c-5.3,4-9.1,11.5-16.8,8.5c1.1-2.8,4.2-4.2,5.3-7c-1.3-0.1-2.5-0.1-3.5,0.9
		c-2,1.9-2.3,5.6-5.3,5.8c-3.6,0.2-11,1.1-9.4-1.7C6.6,168,13.5,164,19,159.1c-0.5-0.5,0.7-2.5-0.7-1.5c-5.1,3.9-9.2,8.3-14.2,12
		c-5.1-6.9,5.9-11.4,9.6-15.8c-5.3-1.4-9.1,8.6-10.5,3.3c-1.2-4.5-1.9-9.2-2.1-13.9c-0.1,0-0.1,0-0.2,0c0,14.1,0.1,28.2,0.2,42.3
		C1.4,185.5,1.8,185.5,2.1,185.5z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M287.6,178.4c0-0.9-1-2.3-1.5-2.3c-27,1.4-53.7-0.2-80.6,0.7c-17.4,0.6-35,0-52.5,0.1c-1.6,0-3.8,1.3-4,2.5
		c-1.2,7.6-0.6,15.1,0.5,22.7c-20.7,1.5-41.4,1.3-62.2,0.5c-9.6-0.4-19.3-1.7-28.9-1.1c-4.1,0.3-8.3,1.5-12.2,1
		c-10.9-1.5-21,0.8-31.6,1.5c-3.6,0.2-11.1-2.6-11.1,3.3c0,2.1,5.6,1.1,3.7,4.2c-0.5,0.8-2.4-2.3-3.9-0.6c-2.3,2.7-0.4,7.8,1.7,7.9
		c94,2.5,187.9,0.7,282-1.9C289.2,204.1,287.2,191.2,287.6,178.4z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M208.9,133c-0.2-0.3-1-0.1-1.6-0.1c1.7,3.4,5.9,5.1,6.7,8.8c0.1,0.4-1.7,1.6-2.1,1.4c-3.5-2.2-6-5.6-8.9-8.5
		c-2.4,2.7,3.5,2,1.8,4.4c7.4,4.2,10,13.6,18.4,16.6c-2.3-5.1-12.2-8.8-8.8-14c7.3,4.6,11.7,12.3,18.4,17.5
		C227.5,147.9,216.1,143.1,208.9,133z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M66.6,93.7C66.6,93.7,66.6,93.7,66.6,93.7c-9,0.4-18.2-1.5-26.8-0.5c-9.9,1.2-20.3,0.5-30.5,0.4
		c-0.8,0-2.1,1.1-1.7,1.1c19.8,1.7,39.4,0.1,59-0.3C66.7,94.1,66.6,93.9,66.6,93.7z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M1.6,46.5c0.2-12.1,1.1-24.1,1.8-36.2c0-0.6,1.8-1.7,2.1-1.5c2.5,1.8,6.2,2.2,6.4,5.8c0.2,2.9-4.7,3.4-3.3,6
		c0.8,1.4,3.7,1,4.1,3.7c0.3,2.1-3,2.6-2.3,3.1C23.3,36,35.3,42.9,48.6,50c15.6,8.3,29,19,43.9,27.7c-0.7,1-0.8,3.2-2.5,2.4
		c-11.8-5.4-22.1-12.5-33.6-18.6c-11.2-6-22.3-11.2-33.9-16.3c-3.3-1.4-5.7-4.4-8.9-5.8c-2.3-1-4.3-2.6-6.9-2.8
		c2.8,4.7,8.2,5.4,12.5,8.4c6.2,4.2,13.1,5.6,18.8,10.3c1.2,1-3.2,1.6-1.4,3c4.9,3.8,11.3,3.9,16.5,7.3c-0.7,1-0.6,3.1-2.6,2.5
		C37.3,64.4,24.9,60.1,12,56.7c-0.2,2,1.6,2.1,2.7,2.5c13.6,4.4,27,7.5,40.2,12.4c-0.2-2.4-3.6-4.9-0.3-4.2
		c13.8,3.2,25.8,11,39.1,15.6c1.4,0.5,3.2-3.3,5.3-4.8c1.3-0.9,3,3.1,5.8,3c-5.9-7.9-16.6-8.9-22.5-16.8c-0.2-0.3,1.3-2.1,1.3-2.1
		c-13.2-10.1-27-17-39.2-27.5c-3.8-3.3-9.6-5.4-12.8-9.8c-0.5-0.7,0.6-2.2,1.3-3.4c0.9-1.7-1.7-1.6-2.2-2.6
		c-1.6-3.2-1.1-7.5-4.6-9.4c-4.3-2.2-10.3,0.5-13.6-3.9c-0.2-0.3,0.8-2.1,1.5-2.1c9.6-0.8,19.2-1.2,28.8,0.2
		c4.4,0.6,7.4,4.7,9.3,8.5c0.5,1.1-1.1,3.3,0.5,5C64,29.6,75.6,40.7,87,53.4c0.2,0.2-0.9,1.5-1.5,2.4c-9.6-7-17.7-16.3-28.9-21
		c14.1,10.4,26.2,23.4,42,31.5c-3-3.5-8.5-5.2-9.8-9c-1-2.8,2.8-3,4.5-2.8c2.8,0.2,4.2,3.6,6.4,5.4c1.3,1,3.7,0.4,5-1.4
		c1.8,1.8,3.2,3.9,5.4,5.1c0.3,0.2,1.2-0.8,0.7-1.5c-1.5-2-4.1-3.3-4.8-5.4c-0.8-2.3,3-2.4,4-4.3c2.8,1.8,3.9,5.9,7.9,6.1
		c-2.5-3.9-5.9-6.9-8.8-10.5c1.1-0.7,1.9-2,3.5-1.8C100.5,31.5,86.4,19.3,73.5,4.8c-0.2-0.2,0.9-2.1,1.5-2.1
		c9.1-0.2,18.3-1.1,27.1,2.3c3.4,11.1,7.3,22.6,15,30.6c3.6,3.8,1.3,9.6,7,10.2c0.1,0-0.7-1.1-0.7-1.4c0.1-1.3,1.9-2.4,2.1-3.6
		c0.7-3.5-2.5-6.4-2.8-9.6c-0.2-1.9,0.9-4.1-0.5-6c-2.1-2.7,2-4,0.9-6.2c-1-2-1.2-4.2-1.4-6.2c-0.1-0.9,0.4-2.8,2.3-2.6
		c-1.1-1.6-0.5-3.7-1.8-5.3c4.4-3.5,9.3-2.5,12.8-1c5,2,1.7,9.4,4,14.1c0.4,0.8,2,1.1,2.3,1.9c0.9,2.4-0.2,5.5,0.6,7.6
		c0.9,2.3,3.9,3,3.9,6.3c1.8-2.3,2.7,0.8,3.4,0.6c1.7-0.7,3-2.4,4.4,0.4c2.2,4.5,0.2,9.2,1.2,13.9c0,0.1,1,0,1.6,0
		c-0.9-14.6-2.9-28.9-0.6-43.7c0.1-0.7,1.5-1.2,2.4-1.8c4.1,11.7-0.3,24.1,2.6,35.9c-0.3-11.7,0.5-23.2-0.6-35.1
		c0-0.5,1.4-1.1,2.3-1.7c4.4,10.2,1.9,21,2.6,31.5c3.4-10.3-2.2-21.3,2.6-31.5c0.1,0.3,0.2,0.5,0.3,0.8c0.1-0.5,0.3-1,0.6-1.4
		c-0.3,0-0.6,0-0.9,0C126.4,1.9,85.1,1.9,44.4,0.8c-0.6,0-1.2,1.4-1.7,1.3c-13.9-1.6-27.5,0-41.2-0.7c-0.1,15-0.2,30.1-0.3,45.1
		C1.3,46.6,1.5,46.5,1.6,46.5z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M1.1,138.4c0.2-4.5,0.9-8.9,2.3-13c2.9-8.4,13.8-4.4,20.8-8.3c-2,0.1-4.9-0.4-3.9-2.4c1.5-2.7,6.5,0.2,9.1-2.9
		c-4.5-0.9-13.3,3.8-11.8-0.4c1.6-4.5,11-2,16.2-5.7c-10.5,0.3-20,5.9-30.6,5.3c-1.5-10.2-1.3-20.4-0.5-30.6c0.1-0.9,1-1.6,2.2-1.8
		c0-0.3,0-0.5,0-0.8c0-0.1-0.1-0.1-0.1-0.2c-0.8,0-1.4-0.4-1.6-1.8c-1.1-8.1-1.6-16.2-1.6-24.2c-0.2,0.1-0.4,0.1-0.5,0.2
		c-0.2,28.9-0.3,57.8-0.2,86.7C1,138.4,1,138.4,1.1,138.4z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M286.8,150.8c0.8,2,1,4.1,1.1,6.4c0.3,0,0.6,0,0.9,0.1c-0.3-51.6-1.1-103.2-1-154.9c-18-0.4-36.1-0.6-54.3-0.7
		c-0.2,0-0.5,0-0.7,0c0,0.2,0,0.3,0,0.5c3.2-0.2,6.6,0.7,8.9,2c1.7,1,2.3,1.6,2.4,2c0.4,0,0.9,0.1,1.3,0.1c0.2,0,0.4,0.1,0.6,0.1
		c0.8-1,1.6-2,2.4-3.1C261,3,273.5,2.5,286.1,4.1c2.2,14.3,0.2,28.6,0.9,42.9c-6.2,4-13.9,4.1-20.1,7.9c2.1,0,4.1-0.3,6.2-0.6
		c2.4-0.4,0.4,4.5,3.4,3.9c3.5-0.7,9.4-4.1,9.7-0.6c2.3,29.8,2.4,59.5,1.8,89.3c-5.5,2.9-11.1-3.3-16.6-3.5
		C275.4,148.8,284.8,145.7,286.8,150.8z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M202.5,4.9c0.1-0.4-1.8-1.6-2.1-1.4c-7.6,5.6-9.8,14.5-15.1,21.6c0.9,0.6,1.8,1.2,2.6,1.8
		C192.5,19.2,200.3,13.9,202.5,4.9z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M184.5,158.1c0.1-0.3,0.3-0.5,0.4-0.6c-6-13.4-15.8-25.1-19.7-39.5c6.9,13.9,15.7,26.8,21.9,41.2
		c-1.9,0.8-1.1-3.1-2.2-1.7c0,0,0,0.1,0,0.1C185,157.6,184.8,157.8,184.5,158.1"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M27.6,35.4c0.8-0.4,3.9-1.9-1.8-3.7c-0.3-0.1-2.3,1.8-1.4,2.9C25,35.4,26.8,35.8,27.6,35.4z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M23.3,25.1c-0.9-0.9-1.8-1.6-2.6-2.7c-0.5-0.8-0.7-1.7-0.9-2.6c-1.3,1.6-5.1,1.4-3.1,5
		C18,27.3,21.1,27.2,23.3,25.1z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M19.8,19c0.3-1.2,1-2.5,0.7-3.4c-0.3-0.8-1.5-1.2-2.4-1.8C18.8,15.6,14.5,16.1,19.8,19z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M134.6,48.1c-0.4,0.1-0.9,1.3-0.8,1.4c6.1,5.9-4,10.7-4.5,16.8c-4.2-2.9-3.4,1-7.1,2.2
		c-0.4,0.1-1.2-3.1-2.2-1.9c-1.1,1.2-0.1,3.9-1.2,5.8c-1.2-1.3-3.3-2.5-4-1.5c-1.4,2,0.9,6.3-3,6.6c-1.4,0.1-2.9-1.8-4.4,0.1
		c2.6,0.9,5.3,1.6,7.9,1.5c1.5-0.1,0.4-2.4,1.1-3.1c3.5-3.4,9.1-3.1,12.5-6c2.8-2.3,3.2-7.2,5.3-10.5c1.4-2.3,4.4-4.2,4.8-7.3
		C135.1,53.2,138,47,134.6,48.1z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M157.3,67.2c-0.4,1.9-1.9,2.7-3.5,2.5c-2.7-0.4-0.7-4.4-2.7-4.8c-1.8-0.4-3,2.8-4.3,2.7
		c-1.7-0.1-1.8-3.4-3.5-4.8c-0.8,1.7-3.2,3.1-0.8,5.2c1.4,1.3,2.9,2.7,4.4,3.3c0.6,0.2,1.2-1.3,1.7-2.3c4.4,2.7,11.2,8.4,14.9,1.8
		C160,72.7,158.5,70.2,157.3,67.2z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M212.5,3.3c-8,13.5-19.3,24-27.8,37.8c-0.2,0.3-0.2,0.6-0.2,0.8c0.9,0.2,1.7,0.5,2.1,1.4c0.1,0,0.1,0,0.2,0
		c4.7-3.9,7.9-8.7,11.7-13.6c6.4-8.1,13.3-14.9,16.2-24.7C214.9,4.6,213.4,3.8,212.5,3.3z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M186.7,43.2c-0.4-0.9-1.2-1.2-2.1-1.4C184.7,42.8,186.2,43.2,186.7,43.2z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M178.3,18.4c0.9,0,2.4-3,2.3-4.6c-0.1-1.1-1.5-4-4.5,0.2C175.3,15.1,174.3,18.4,178.3,18.4z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M153.1,8.2c-2-2.8-2.4,4.4-2.7,7.3c-0.2,2.4-0.5,4.8,0.8,7C155.6,19.9,155.5,11.6,153.1,8.2z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M146.1,15.5c-0.2,4.7-1.1,9.4,0.7,14c0.9-0.6,2.3-1.1,2.3-1.8c0.3-8.1,1.4-16.4-0.6-24.5
		C143.9,5.3,146.3,11.3,146.1,15.5z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M98.9,44.1c0.2,0.2,1.5-0.9,2.4-1.5c-6.8-8.4-13.6-16.3-23-22.5c-0.4-0.2-2.2,0.9-2.1,1.5
		c0.1,1.7,1.8,3.1,3.2,4.4C85.7,32.5,92.1,38.2,98.9,44.1z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M86.6,44.2c0.2,0.2,1.5-0.9,2.4-1.5c-4.9-7.1-11.5-12.2-17.4-18.5c-5.5-5.9-10.9-11.1-17-16.3
		c-0.2-0.2-1.5,0.9-2.4,1.5C62.1,22.5,74.7,32.6,86.6,44.2z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M76,21.4c0.5,0.2,1.6-0.9,2.5-1.5c-2.9-3.8-6.3-7-9.8-10.3c-2.3-2.1-1.9-5.8-4.4-6.9c-1.3-0.6-5.3-1.2-4.1,1.9
		C62.7,11.5,68.9,17.6,76,21.4z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M237,55.2c-1.6-0.3-3.4,0.9-5.2,1.4c0.9,0.9,1.6,2,2.7,2.5c1.1,0.5,2.4-0.2,3.4-0.8
		C240.4,56.7,237.8,55.4,237,55.2z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M239.7,59.6c-8.6,1-16.5,4.5-24.6,7.6c1.7,5.4,7,0.7,10.5-0.2c5.4-1.5,10.8-2.6,15.8-5.1
		C240.8,61,240.2,59.6,239.7,59.6z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M249.3,71.9c-10.5,1.4-20.6,3.8-30.7,6.7c2.5,5.9,8.7,0.7,13.1,0.6c6.6-0.3,12.9-3,19.3-4.9
		C250.4,73.3,249.8,71.8,249.3,71.9z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M185.9,97c0,0.1,0,0.2,0,0.3c0.7-0.3,1.4-0.6,2.2-0.8c-0.3-0.1-0.7-0.3-1-0.4c0.7-1,0.6-3,2.6-2.6
		c20.7,4.5,39.4,10.4,59.6,13.9c-19.1-6.9-39.2-9.5-58.7-14.9c0.6-0.9,1.2-2.4,1.7-2.3c29.2,3.5,57,10.4,85.9,13.7
		c-20-5.9-41-6.7-61.3-11.4c0.6-0.9,1.2-2.3,1.7-2.3c18.4,0.5,36.8,1.6,55.2,2.3c0-0.6,0.1-1.5-0.1-1.6c-8.1-2.2-19.7,3.5-25.3-3.7
		c6.4-1.9,12.7,0,19.2-1.1c0.1,0,0.1-1.3,0-1.4c-6-1.2-11.6,0.7-17.5,0.8c-11.1,0.2-22.1-1.4-33.4,2.2c-3.6,1.1-7.5,0.5-11.3-0.5
		c0.2,2-1.5,2.2-2.7,2.5c-6.7,1.6-12.5-3.9-19.2-1.6c1.5-0.1,3,0.2,4.4,0.9c-1.6,2.1-3.5,4-5.3,6.1C183.9,95.8,185.7,96.2,185.9,97z
		"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M188.9,3.4c-0.8,0.4-1.2,1.6-1.8,2.4c1.5,0,2.9,0,4.4,0C190.7,4.9,190.7,2.7,188.9,3.4z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M123.2,112.7c-0.9-3.2-4.2-2.3-5-4.5c-1.2-3.1-2.6-4-4.6-4.3c1.7-2.4,1.1-6.3-2.6-6.1c0-2.7,4-5,2.2-6.6
		c-1-0.9-3.6-1.3-5.7-1.3c4.3,2.6,1.2,6.1,0.9,9.6c1.8-2.3,2.8,0,3.3,1c1.2,2.2-1.8,4.7-0.4,6.7c0.5,0.7,2.2-0.7,3.2-0.4
		c2,0.7,1.3,3.4,2.2,4.8c1.3,2.2,4.9,0.4,4,4.6c1.7,0,3.5,0.3,4.4-1.7c2.3,1.2,4.7,4.2,7,1.7c-2.3-1.1-4.1-2.6-6.2-4.2
		C124.9,111.4,124,112.2,123.2,112.7z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M98.7,112.7c-2,0.1-4.6,0.1-4-2.6c0.2-0.8,2-1.2,3.2-1.8c-2.7-2.8-7.3,3.1-6.5-2.5c0.3-1.7,3.9-1,5.6-2.7
		c-0.9-0.9-2.4-1.9-2.3-2.6c0.8-3.5-2.2-5.2-2.1-8c-0.6,0-1.5-0.1-1.6,0.1c-0.9,2.1,2.2,4.6,1.2,5.7c-3.6,4-9.9,4.2-14.5,7.4
		c2.7,1,1.3,2.8,0.9,4.4c0.6,0,1.3-0.2,1.7,0.1c1.7,1.2,2.9,3.6,1.5,4.8c-19.2,16.2-38.5,29.6-55.6,47.8c-0.9,1-3.4,2.2-1.1,4.2
		c13.7-17.9,32-30.1,50.1-44.4c0.3-0.2,1.5,0.9,2.4,1.5c-12.4,14.4-29.9,23-41.2,38.5c9.1-3.7,11.7-15.1,21.1-18.1
		c0.3-0.1,1.6,1.7,1.4,2.1c-2.8,4.5-7.9,7-9.4,12.4c6.1-4.1,9-11.8,15.9-14.6c0,0,0.1,0,0.1,0.1c0-0.1,0-0.1,0-0.2
		c8.1-10.4,20.7-15.4,26.9-27.4c3.6,3.2,5.4,1.6,6.9-0.1C100.6,115.6,96.1,114.7,98.7,112.7z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M66.9,146.7c-3.2,4.2-6.7,7.9-10.2,11.6c0.5,0.5-0.5,2.6,0.6,1.5c10.7-11.8,23.9-19.8,34.5-31.2
		c1.2,1.3,1.9,2.3,1.2,4.5c-4.1,13.1-12.4,24.2-14.3,37.6c7.7-14.9,13.1-30.8,19.3-46.4c-1.8,0-4.1-0.6-5,0.3
		c-8.2,8.2-15.4,17.4-25.8,22.2c0,0-0.1,0-0.1-0.1C66.9,146.6,66.9,146.6,66.9,146.7z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M94.3,110.4c-4-0.1-9.3,0.4-10.8,5.1c-0.8,2.6,3.9,2.9,5.5,5.1c2.3-3.4,3-6.3,7-7.9
		C95.4,111.8,94.9,110.4,94.3,110.4z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M23.3,155.6c18.8-11.1,32.7-27.2,49.8-41.3c0.1-0.1-0.4-1-0.7-1.6C56.8,127.9,39.5,141.1,23.3,155.6z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M154.7,103.1c0,1.5,0.7,3.4,0.4,4.2c-1.3,3.6-3.8,0.4-5.5,1.3c-0.4,0.2-0.1,1.5-0.1,2.4c0,0.9,0,1.7,0,2.6
		c1.9-2.6,4.9-3,7.9-2.6c-0.1-2-0.2-4.1,1.8-5.1c0.8-0.4,2.7-0.1,2.2-0.8C159.8,102.3,156.5,107.1,154.7,103.1z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M168.7,81.2c-2.8-0.1-5.2,2.9-4.2,5.2c0.3,0.6,1.5,0.7,2.4,1c-0.8,1.2-1.7,2.3-2.5,3.6
		c-0.7,1.2,0.8,1.3,1.6,1.7c-2.2,4,0.8,8,3.5,10.5c1.4-3.1-5.2-6.6,0.8-8.3c0.4-0.1-0.4-1.5-1.3-2.5c-2-2.3,4.2-3.3,2.7-4.4
		C169.2,86,166.6,84.4,168.7,81.2z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M174,117.1c-2.3,5.3,2.6,8.7,3.9,13c1.9,6.3,4.8,12,8.8,17.4c5.1,6.9,5.7,16,13.6,20.4
		C190.8,151.3,180.2,135.3,174,117.1z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M184.2,123.3c-0.1-0.4-1.5-0.6-2.3-0.9c-0.3,2.6,0.7,4.9,2,6.9c5.2,8.4,7.9,17.6,14.7,24.7
		c0.7-2.8-1.5-4.2-2-5.7C193.8,140.2,185.4,131.6,184.2,123.3z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M108.3,128.5c-6.8,13-9.8,27.3-14,41.2c7.3-11.9,8-26.2,14-38.5c0.5,0.4,1.4,0.6,2,0.9
		c-0.7-0.6-1.1-1.4-1.2-2.7C109,129,108.6,128.8,108.3,128.5z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M101.3,128.5c-4.5,13.4-12.7,25.6-13.1,40.3c4.2-13.3,9.7-25.9,13.9-39.4C102.1,129.1,101.6,128.8,101.3,128.5
		z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M136.4,153.9c1.6,6.2,0.4,12.3,1.7,18.4c3.3-5.2-3.8-12.7,2.6-15.8c1.8,5.1,0.5,10.9,3.5,15.8
		c-0.6-9.2-1.9-18.3-4.4-27.1C138.2,147.9,135.4,150.1,136.4,153.9z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M132.8,152.1c-2,1.5-0.6,3.5-0.7,5.3c-0.4,5-0.1,9.9-0.1,14.9C134.1,165.6,132.1,158.8,132.8,152.1z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M128.4,160c-2.2,3.6-0.2,7.6-0.9,11.4C129.6,167.7,127.8,163.8,128.4,160z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M193.2,117.9c0.4-0.1,0.8-0.5,0.8-0.8c-0.1-0.7-0.8-1.1-1.6-0.9C192.9,116.7,191.3,118.4,193.2,117.9z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M184.5,112.7c0.5,0.5-1.1,2.1,0.9,1.7c0.4-0.1,0.8-0.5,0.8-0.8C186,112.9,185.3,112.5,184.5,112.7z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M179.3,109.9c-2.9-1.4,1.3-1.3,0.8-2.5c0.6,0.4,1.3,1,0.8,1.7C180.5,109.6,179.7,110.1,179.3,109.9z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M175.9,66.2c-0.8-1.7,1.1-0.2,1.6-0.8C177.7,67.3,176,66.4,175.9,66.2z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M196.6,137.3c-0.4-2.1-1.6-3.9-3.4-5.3c-0.5-0.4-1.1-0.6-1.7-0.9c-0.5,3.2,3.3,3.9,3.8,7
		C195.3,138.4,196.7,137.8,196.6,137.3z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M133.6,134.6c0.5,1.9-1.2,0.3-1.7,0.9c0-0.6-0.2-1.4,0.1-1.6C132.6,133.3,133.4,133.9,133.6,134.6z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M133.1,127.5c-0.6-1.8,1.6-0.2,2.3-0.8C134.8,127.8,133.3,128,133.1,127.5z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M189.7,60.2c0.6,0,1.4-0.2,1.6,0.1c0.6,0.6-0.2,1.2-0.8,1.7C190.3,61.3,190,60.8,189.7,60.2z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M183.6,63.7c-0.9,0.2-1.2-0.1-0.9-0.9c0.5-1.3,1.6-0.8,2.6-0.9c0,0.6,0.2,1.4-0.1,1.7
		C184.9,63.9,184.2,63.6,183.6,63.7z"
      />
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M133.7,35.5c-0.6,0-1.3-0.9-0.8-1.5c0.3-0.3,1.3-0.3,1.5,0C135,34.6,134.3,35.5,133.7,35.5z"
      />
    </g>
    <g
      id="Color_4"
      className={`${isolatedLayer === 5 ? "fill-group focus" : "fill-group"} `}
    >
      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M138.5,178.3c-5.2-3-12.4-1.1-18.8-1.1c-31,0.1-61.9-1.1-92.8,0.1c-5.4,0.2-11.1-1-16.9,1.3
		c-0.6,0.2-2.4-1.7-4.1-1.1c-1,0.3-2.2,0.9-2.4,1.7c-1.6,5.7-2.7,11.4,0.7,17.5c18.7-0.8,37.1,0.7,56.1-1.5c6.4-0.8,12.8,0,19.2-0.4
		c3.1-0.2,3.3-5.8,5.9-4.6c0.8,0.4-2.2,3.6,0.4,4.1c17.8,3.7,34.9,0.1,52.4,0.5c0.9,0,2.3-1,2.3-1.6
		C140.5,188,143.5,181.3,138.5,178.3z M15.4,183.6c-0.4,0.5-1.2,1-1.6,0.8c-2.5-1.3,0.9-1.5,0.8-2.5
		C15.2,182.3,15.9,182.9,15.4,183.6z M74,186.2c-0.3,0.3-1.1,0.2-1.6,0c-0.7-0.2-1.3-1-0.8-1.6c0.3-0.3,1.1-0.2,1.6,0
		C73.9,184.8,74.6,185.6,74,186.2z M129.3,189.8c-0.5-0.5-2,1.1-1.8-0.9C128,189.5,129.5,187.8,129.3,189.8z"
      />

      <path
        className="cell-base"
        vectorEffect="non-scaling-stroke"
        d="M287.6,178.4c0-0.9-1-2.3-1.5-2.3c-27,1.4-53.7-0.2-80.6,0.7c-17.4,0.6-35,0-52.5,0.1c-1.6,0-3.8,1.3-4,2.5
		c-1.2,7.6-0.6,15.1,0.5,22.7c-20.7,1.5-41.4,1.3-62.2,0.5c-9.6-0.4-19.3-1.7-28.9-1.1c-4.1,0.3-8.3,1.5-12.2,1
		c-13.8-1.8-26.9,0.7-40.2,2.2c-7.2,0.8,2.6,3,1.2,6.8c-0.2,0.6-2.3-2.4-3.8-0.6c-2.3,2.7-0.5,7.7,1.7,7.9
		c37.2,3.1,74.1,0.9,111.1,0.4c57-0.8,113.9,0.9,170.8-2.3C289.2,204.1,287.2,191.2,287.6,178.4z M41.6,210.8
		c-0.1,0.7-0.9,1.3-1.6,0.8c-1.6-1.2-1-2.9,0-4.2c0.4-0.5,1.1-0.6,1.7-0.9C41.7,207.9,41.9,209.3,41.6,210.8z M62.7,211.7
		c0.8-0.2,1.3,0.3,1.8,0.9C63.6,212.8,63.2,212.3,62.7,211.7z M95.1,211.6c-0.2,0-0.6-0.5-0.9-0.8c0.9-0.5,1.2-2.1,2.6-1.8
		C96.6,209.9,98.1,211,95.1,211.6z M162.6,201.1c-0.3,0-0.8-0.5-0.7-0.7c0.1-0.7,1-1.3,1.5-0.8C163.9,200.1,163.2,201,162.6,201.1z
		 M163.4,189.7c-0.8,0.4-1.2-0.1-0.8-0.8c0.3-0.7,1.1-1.3,1.6-0.8C164.8,188.7,164.1,189.4,163.4,189.7z M184.3,212.4
		c-0.5,0.6-1.6-0.3-2.4-0.7c0.3-0.3,0.5-0.7,0.9-0.8C184,210.5,185,211.5,184.3,212.4z M192.4,200.3c-0.9,0.3-1.3-0.3-1.8-0.9
		c2,0,4.1,0,6.1,0C195.6,201.1,193.8,199.8,192.4,200.3z M216.8,195c-0.2,0.1-0.6,0-0.8,0c0.6-1.6,1.9-3.6,3.2-2.3
		C220.3,193.8,217.9,194.3,216.8,195z M221.3,212.4c-0.7-0.1-1.4-1-0.8-1.5c0.7-0.6,1.7,0.3,2.5,0.7
		C222.4,212,221.8,212.5,221.3,212.4z M255.3,202c-0.4,1.3-1.6,0.8-2.6,0.9c0-0.6-0.2-1.4,0.1-1.7c0.6-0.6,1.6-0.7,2.5-1
		C255.4,200.9,255.5,201.5,255.3,202z M271.2,211.7c0-0.6,0-1.2,0-1.8c0.6,0.3,1.4,0.5,1.6,0.9C273.4,212.7,271.6,211.1,271.2,211.7
		z M278.1,184.4c-0.3,0.3-1.1,0.1-1.7,0.1c-0.6,0-1.4,0.2-1.6-0.1c-0.6-0.6,0.1-1.4,0.8-1.6c0.8-0.2,1.9-0.4,2.5,0.1
		C278.4,183.1,278.4,184.1,278.1,184.4z"
      />
    </g>
    <g id="Outline_-_match_color_and_line_weight_to_cell_1">
      <rect
        x="2"
        y="1.8"
        className="cell-nav-outline"
        vectorEffect="non-scaling-stroke"
        width="285.8"
        height="218.7"
      />
    </g>
  </svg>
);

export default React.forwardRef(cell4);
